module.exports = __webpack_public_path__ + "static/media/fiona.f27a2d2b.png";